import * as yup from 'yup'

export const userAccrualValidationSchema = yup.object().shape({
    bonus_id: yup.string().required('Выберите бонус'),
    amount: yup.number().typeError('Укажите число').required('Укажите количество бонусов'),
    comment: yup.string()
})